import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import { Accordion } from '../../../../components/base/Accordion/Accordion';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import DriverDTO from '../../../../dto/DriverDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';

export default function DriverForm(props) {
  const { control, formMeta } = props;
  const dto = new DriverDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_last_name}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_first_name}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_middle_name}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_external_id}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_inn}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          withLabel
          changeFormat="YYYY-MM-DD"
          onChangeToIso
          hideTime
          dtoObject={attributes.driver_birth_date}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_citizenship}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_phone}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_email}
          variant="material"
        />
      </Row>
      <div className="mb-2" />
      <Accordion
        isOpen
        content={(
          <>
            <Row className="row-cols-3">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_identity_type}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_identity_series}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_identity_number}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_birth_place}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                withLabel
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                dtoObject={attributes.driver_identity_issue_date}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_identity_issuer}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_identity_issuer_code}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_email}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1 mb-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="file"
                component={FileInput}
                dtoObject={attributes.driver_photo_with_identity}
                variant="material"
              />
            </Row>
          </>
                      )}
        title="Документ, удостоверяюший личность водителя"
      />
      <Accordion
        isOpen
        content={(
          <>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_license_series}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_license_number}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                dtoObject={attributes.driver_license_valid_from_date}
                withLabel
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                withLabel
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                dtoObject={attributes.driver_license_valid_until_date}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                withLabel
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                dtoObject={attributes.driver_license_issue_date}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_license_issuer}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_license_experience}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_license_issuer_country}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1 mb-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="file"
                component={FileInput}
                dtoObject={attributes.driver_license_scan}
                variant="material"
              />
            </Row>
          </>
                      )}
        title="Водительское удостоверение"
      />
      <Accordion
        isOpen
        content={(
          <>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_criminal_record_series}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_criminal_record_number}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                withLabel
                changeFormat="YYYY-MM-DD"
                onChangeToIso
                hideTime
                dtoObject={attributes.driver_criminal_record_issue_date}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_criminal_record_issuer}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1 mb-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="file"
                component={FileInput}
                dtoObject={attributes.driver_criminal_record_scan}
                variant="material"
              />
            </Row>
          </>
                      )}
        title="Справка о наличии (отсутствии) судимости и (или) факта уголовного преследования либо о прекращении уголовного преследования"
      />
    </>

  );
}
